import React from "react";
import "./Transport.scss";

const mapEmbeded = `<div style="width: 100%; filter: grayscale(100%) contrast(120%) brightness(90%)">
  <iframe width="100%" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
    src="https://maps.google.com/maps?width=100%25&amp;height=320&amp;hl=en&amp;q=Хотел%20Теризис,%20с.%20Българево&amp;t=&amp;z=11&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
  </iframe>
</div>`;

const mapEmbededSecond = `<div style="width: 100%; filter: grayscale(100%) contrast(120%) brightness(90%)">
  <iframe width="100%" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
    src="https://maps.google.com/maps?width=100%25&amp;height=320&amp;hl=en&amp;q=%D1%85-%D0%BB%20%E2%80%9C%D0%A1%D0%BF%D0%B5%D1%80%D0%B0%D0%BD%D1%82%D0%B0%E2%80%9D,%20%D1%81.%20%D0%9A%D1%80%D0%B0%D0%BD%D0%B5%D0%B2%D0%BE+(%D1%85-%D0%BB%20%E2%80%9C%D0%A1%D0%BF%D0%B5%D1%80%D0%B0%D0%BD%D1%82%D0%B0%E2%80%9D,%20%D1%81.%20%D0%9A%D1%80%D0%B0%D0%BD%D0%B5%D0%B2%D0%BE)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
  </iframe>
</div>`;

export default function Transport() {
  return (
    <div className="p-top-8 p-bottom-8 transport bg-third" id="transport">
      <div className="container p-top-4">
      <h3 className="text-center m-bottom-4 m-top-1">С кого да се свържа в деня на сватбата?</h3>
        <div className="flex flex-justify-center text-center m-bottom-6">
          <div className="col-12 col-8-xl">
            <p className="text-md m-bottom-2 text-justify-xs text-justify-sm">
              При възникнали въпроси от всякакво естество в деня на сватбата, можете да се свържете с нашия сватбен агент: 
            </p>
            <p className="m-top-2 m-bottom-2 text-lg m-bottom-4">
            Симона Кирилова: 
            <br/>
            <i className="fa-solid fa-phone m-right-1 m-top-1"></i><span className="font-weight-700 m-top-1">+359 890 111 439</span>
            </p>
          </div>
        </div>
        <hr className="m-bottom-8 m-inline-12 m-inline-1-xs"/>
        <h1 className="text-center m-bottom-4">Как да стигна?</h1>
        <div className="flex flex-justify-center text-center">
          <div className="col-12 col-8-xl">
            <p className="text-md m-bottom-2 text-justify-xs text-justify-sm">
            Локацията, която избрахме за нашия сватбен ден е х-л “Теризис”, който се намира в с. Българево. 
            <span className="font-weight-700">{" "}Настаняването на всички, които не са от региона, ще бъде осигурено от нас в х-л “Сперанта”, с. Кранево. {" "}</span> 
Ще има и транспорт в посока и обратно до локацията на събитието, по ваше желание.
            </p>
          </div>
        </div>
        <div className="flex flex-justify-center gap-5-xl">
          <div className="col-12 col-4-xl m-top-2">
            <h4 className="text-center font-body m-block-1"> хотел “Теризис" <br/> с. Българево”</h4>
            <p className="text-xs text-center">(Цъкни върху "View larger map")</p>
            <div className="display-block m-auto p-top-3 p-bottom-5">
              <div
                className="map-location"
                dangerouslySetInnerHTML={{ __html: mapEmbeded }}
              />
            </div>
          </div>
          <div className="col-12 col-4-xl m-top-2">
            <h4 className="text-center font-body m-block-1"> хотел “Сперанта” <br/> с. Кранево</h4>
            <p className="text-xs text-center">(Цъкни върху "View larger map")</p>
            <div className="display-block m-auto p-top-3 p-bottom-5">
              <div
                className="map-location"
                dangerouslySetInnerHTML={{ __html: mapEmbededSecond }}
              />
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}
